/*----------VARIANT SELECTOR > Some JS can be found in the front-end project in variant-options.tpl --------------------*/
import { createLoader } from 'helpers/loader/loader';
import getTranslation from 'helpers/translation/getTranslation';
import { Alert } from 'components/alert/alert';
import getStorageStatus from 'helpers/localstorage/getStatus';

export default (function () {
    /*-----------------------------ELEMENTS-----------------------------*/
    const elements = {
        variantsContainer: document.querySelector('.product-variant-options')
    };

    const selectedValues = productObj && productObj.variantSelector ? productObj.variantSelector.selected : null;
    let products = productObj && productObj.variantSelector ? productObj.variantSelector.options : null;
    if (products) {
        products = Object.entries(products).map(([key, value]) => ({ key, value }));
    }
    // AB-130
    const filterValuesEl = document.querySelector('.variant-values');
    if (filterValuesEl) {
        const values = [];
        Object.entries(selectedValues).forEach((value) => {
            if (typeof value[1] === 'boolean') {
                if (value[1]) {
                    values.push(`${value[0]}: ${getTranslation('default', 'YES').toLowerCase()}`);
                } else {
                    values.push(`${value[0]}: ${getTranslation('default', 'NO').toLowerCase()}`);
                }
            } else {
                values.push(value[1]);
            }
        });

        filterValuesEl.textContent = Object.values(values).join(', ');
    }
    // END AB-130

    /*-----------------------------CHECK IF ARRAY CONTAINS VARIANT VALUES------------------------------*/
    const containsValues = (product) => {
        let isCorrectProduct = true;
        for (const key in selectedValues) {
            //Check if key (selectedItem) is equal to a value in products
            if (product['value'][key] !== selectedValues[key]) {
                //Return false if the value isn't in the array
                isCorrectProduct = false;
            }
        }
        if (isCorrectProduct === true) {
            return true;
        }
        return false;
        //Return true if all the values are available in the variant.
    };
    /*-----------------------------INIT FUNCTION------------------------------*/
    const init = () => {
        //Destructure elements from elements object
        const { variantsContainer } = elements;

        const alertDiv = document.createElement('div');
        const alertParentDiv = document.querySelector('.p-images-cart');
        alertDiv.setAttribute('class', 'col-xl-12 partial-alert');
        alertParentDiv.insertAdjacentElement('afterbegin', alertDiv);

        if (localStorage.getItem('partialMatch')) {
            const alert = new Alert({ container: '.partial-alert' }); //Create new alert
            alert.setMessage(getTranslation('product', 'VARIANT_ALERT')); //Set message
            alert.setVariant('info'); //Set variant
            alert.show(); //Show the alert
            localStorage.removeItem('partialMatch');
        }
        //Check if variant container exist
        if (variantsContainer) {
            //Add eventlistener to variants container
            variantsContainer.addEventListener('change', (e) => {
                const variantButton = e.target.closest('.custom-variant-button'); //Check if event is on a button
                //Check if clicked on a button
                if (variantButton) {
                    e.preventDefault(); //prevent default just in case.
                    //Create loader icon
                    createLoader(variantsContainer);
                    const attributeTitle = variantButton.getAttribute('data-attribute-title'); //Get title attribute

                    let url = '/';

                    if (document.querySelector('body').getAttribute('data-language') !== '') {
                        url = `/${document.querySelector('body').getAttribute('data-language')}/`;
                    }

                    if (attributeTitle) {
                        if (variantButton.value === 'false' || variantButton.value === 'true') {
                            selectedValues[attributeTitle] = variantButton.value === 'true'; //Reset current selected value with new value
                        } else {
                            selectedValues[attributeTitle] = variantButton.value; //Reset current selected value with new value
                        }
                        const foundProduct = products.find(containsValues); //Check if the new selected product exists.
                        //Check if a product is found
                        if (foundProduct) {
                            url += 'p/' + foundProduct['key']; //Create the url
                        } else {
                            const foundPartial = products.find(
                                (product) => product['value'][attributeTitle] === selectedValues[attributeTitle]
                            );
                            //get first partial match
                            url += 'p/' + foundPartial['key'];
                            if (getStorageStatus('localStorage') === 'available') {
                                localStorage.setItem('partialMatch', 'true');
                            }
                        }
                    }

                    //Go to new variant page
                    if (url) {
                        window.location.href = url;
                    }
                }
            });
        }
    };
    /*-----------------------------PUBLIC METHODS------------------------------*/
    return {
        init: init
    };
})();
